import type { DeviceInfoPayload } from '@muzly/shared';

/**
 * 네이티브 셸이 준 안전 영역을 `--safe-area-*` 로 건다. 셸의 주입 스크립트도 같은 변수를
 * 걸지만 Android 에서는 믿을 수 없다 — 2026-09-23 실기기, 앱 안 새로고침 뒤
 * `__MUZLY_DEVICE_INFO__` 는 살아 있는데 변수는 전부 비어 있었다(주입이 문서 시작
 * 경쟁에 진다). 변수가 비면 레이아웃은 `env(safe-area-inset-*)` 로 떨어지는데, 셸이
 * 시스템 바를 비워 둔 Android 에서 그 값은 바 높이 그대로라 하단이 두 배로 떴다.
 * 그래서 웹이 부팅할 때 살아 있는 전역에서 한 번 더 건다. 브라우저에서는 아무것도 안 한다.
 */
export const applyNativeSafeArea = (
  info: Pick<DeviceInfoPayload, 'safeArea'> | null | undefined,
  root: HTMLElement = document.documentElement,
): void => {
  const insets = info?.safeArea;
  if (!insets) {
    return;
  }
  root.style.setProperty('--safe-area-top', `${insets.top}px`);
  root.style.setProperty('--safe-area-bottom', `${insets.bottom}px`);
  root.style.setProperty('--safe-area-left', `${insets.left}px`);
  root.style.setProperty('--safe-area-right', `${insets.right}px`);
};
